//components
import { PillLink } from '@/containers-ai/Buttons';
import { Grad } from '@/containers-ai/SectionHeading';

//containers
import { HeroVisual } from './HeroVisual';

//styles
import {
  HeroSection,
  HeroInner,
  HeroTop,
  HeroCopy,
  Eyebrow,
  HeroTitle,
  HeroSub,
  CtaRow,
  HeroImageWrap,
} from './Hero.styles';

export function Hero() {
  return (
    <HeroSection id="top">
      <HeroInner>
        <HeroTop>
          <HeroCopy>
            <Eyebrow>THE AUTONOMOUS TRANSPORTATION EXECUTION PLATFORM</Eyebrow>
            <HeroTitle>
              One connected platform.
              <br />
              <Grad>Run by AI.</Grad>
            </HeroTitle>
            <HeroSub>
              One platform &mdash; the Loadsmart’s AI-native TMS and the
              industry&rsquo;s leading dock scheduling, gate and yard network
              &mdash; runs your complete freight lifecycle.
            </HeroSub>
            <HeroSub>
              <b>Loadsmart AI does the work</b> and writes every outcome back
              into your system of record. When an exception appears,{' '}
              <b>our Freight Experts take care of it.</b>
            </HeroSub>
            <CtaRow>
              <PillLink className="qlf-btn-4" href="/contact/#contact-form">
                Book a demo &#8594;
              </PillLink>
            </CtaRow>
          </HeroCopy>

          <HeroImageWrap>
            <HeroVisual />
          </HeroImageWrap>
        </HeroTop>
      </HeroInner>
    </HeroSection>
  );
}
